export default __webpack_public_path__ + "static/media/move-note.febc2e73.webp";